import styled from 'styled-components';
import Text from '../../../../../../components/Text';
import StatisticItem from '../../../components/StatisticItem';
import { DatePicker, Form, Select } from 'antd';
import { useEffect, useState } from 'react';
import accountApis from '../../../../../../services/accountApis';
import Button from '../../../../../../components/Button';
import IcMoney from '../../../../../../components/Icon/icons/IcMoney';
import IcCall from '../../../../../../components/Icon/icons/IcCall';
import { IReportVoiceParams } from '../../../../interfaces/apis';
import dayjs from 'dayjs';
import useGetSummaryReportVoice from '../../../../services/hooks/useGetSummaryReportVoice';
import { formatCurrency } from '../../../../../../utils/formatCurrency';

interface ReportVoiceHeaderProps {
  params?: IReportVoiceParams;
  setParams?: (params: IReportVoiceParams) => void;
}

const ReportVoiceHeader = ({ params, setParams }: ReportVoiceHeaderProps) => {
  const [form] = Form.useForm();
  const [listSalon, setLstSalon] = useState<any[]>([]);

  const { data, setParams: setSummaryParams } = useGetSummaryReportVoice();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await accountApis.filterSalon(null, null, 1, 10000);

        if (response?.status === 200) {
          setLstSalon(response.data.data.content);
        }
      } catch (error) {}
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (params) {
      form.setFieldsValue({
        startDate: params.startDate ? dayjs(params.startDate) : null,
        endDate: params.endDate ? dayjs(params.endDate) : null,
        shopId: params.shopId || '',
      });
    }
  }, [params]);

  const handleFinish = (values: any) => {
    setParams && setParams({ ...params, ...values });
    setSummaryParams(values);
  };

  return (
    <Container>
      <Text variant='H5' style={{ fontWeight: 600 }}>
        Report Voice
      </Text>
      <Content>
        <StatisticItem label='Voice Cost' value={formatCurrency(data?.totalCost || 0)} icon={<IcMoney fill='#EBA33B' width={48} height={48} />} />
        <StatisticItem label='Voice Call' value={data?.totalVoice || 0} icon={<IcCall fill='#DC5500' width={48} height={48} />} />
      </Content>
      <Form layout='vertical' className='styled-form' form={form} onFinish={handleFinish}>
        <Form.Item name='startDate' noStyle>
          <DatePicker style={{ width: '20%' }} format='MM-DD-YYYY' showTime={false} placeholder='Start date' />
        </Form.Item>
        <Form.Item name='endDate' noStyle>
          <DatePicker style={{ width: '20%' }} format='MM-DD-YYYY' showTime={false} placeholder='End date' />
        </Form.Item>
        <Form.Item name='shopId' noStyle>
          <Select
            size='large'
            defaultValue={''}
            showSearch
            optionFilterProp='label'
            className='filter-select'
            style={{ flex: 1 }}
          >
            <Select.Option value={''} label={'All Salon - Zipcode'}>
              All Salon - Zipcode
            </Select.Option>
            {listSalon.map((item: any) => (
              <Select.Option key={item.shopId} value={item.shopId} label={`${item.shopName} - ${item.zipCode}`}>
                {item.shopName} - {item.zipCode}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Button variant='SECONDARY' className='styled-button' htmlType='submit'>
          Search
        </Button>
      </Form>
    </Container>
  );
};

export default ReportVoiceHeader;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

    .styled-form {
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: 100%;

    .ant-form-item {
      margin-bottom: 0;
    }

    .filter-select {
      width: 200px;
      height: 48px;
    }

    .styled-button {
      height: 48px;
    }
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;
